import React, { ReactNode } from "react";
import { Card } from "@/components/ui/card";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

export const CollapsibleCard = ({
                                  title,
                                  children,
                                  defaultOpen,
                                  onOpenChange,
                                  collapsible = true
                                }: {
  title: string | ReactNode;
  children: ReactNode;
  defaultOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  collapsible?: boolean;
}) => {
  return (
    <Card className="p-3 lg:p-4">
      <Collapsible
        defaultOpen={collapsible ? defaultOpen : true}
        open={collapsible ? undefined : true}
        onOpenChange={collapsible ? onOpenChange : undefined}
        className="group/collapsible flex flex-col gap-2"
      >
        {collapsible ? (
          <CollapsibleTrigger asChild>
            <div className="flex flex-row items-center gap-2 cursor-pointer hover:opacity-80 transition-opacity">
              <ChevronDown
                size={14}
                className={cn(
                  "transition-transform duration-200 flex-shrink-0",
                  "group-data-[state=open]/collapsible:rotate-180"
                )}
              />
              <h4 className="font-semibold text-lg sm:text-xl w-full" style={{ color: '#1E293B' }}>
                {title}
              </h4>
            </div>
          </CollapsibleTrigger>
        ) : (
          <div className="flex flex-row items-center gap-2">
            <h4 className="font-semibold text-lg sm:text-xl w-full" style={{ color: '#1E293B' }}>
              {title}
            </h4>
          </div>
        )}
        <CollapsibleContent>
          {children}
        </CollapsibleContent>
      </Collapsible>
    </Card>
  );
};